import styled from 'styled-components';
import { useCallback, useState } from 'react';
import arrowIcon from '../../assets/arrow.png';
import btnimg from '../../assets/btn.png';

const SearchBar = ({ onSearch }) => {
  const [mode, setMode] = useState(1); // 1: 전체, 2: 제목, 3: 내용
  const [query, setQuery] = useState('');

  const handleSubmit = useCallback(
    (e) => {
      e.preventDefault();
      onSearch(query.trim(), mode);
    },
    [onSearch, query, mode]
  );

  const onKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      onSearch(query.trim(), mode);
    }
  };

  return (
    <SearchContainer>
      <SearchForm onSubmit={handleSubmit}>
        <SearchSelect
          value={mode}
          onChange={(e) => setMode(Number(e.target.value))}
          aria-label="검색 옵션"
        >
          <option value={1}>전체</option>
          <option value={2}>제목</option>
          <option value={3}>내용</option>
        </SearchSelect>

        <SearchInput
          type="text"
          value={query}
          placeholder="검색어를 입력하세요"
          onChange={(e) => setQuery(e.target.value)}
          onKeyDown={onKeyDown}
          aria-label="검색어"
        />

        <SearchButton type="submit" aria-label="검색">
          <img src={btnimg} alt="검색" />
        </SearchButton>
      </SearchForm>
    </SearchContainer>
  );
};

export default SearchBar;

/* styles */
const SearchContainer = styled.div`
  color: #333333;
  font-family: 'koPubWorld DotumB';
  flex-shrink: 0;

  @media (max-width: 767px) {
    margin-bottom: 5%;
  }
`;

const SearchForm = styled.form`
  --ctl-h: 38px; /* 공통 컨트롤 높이 */
  display: flex;
  align-items: center;
  gap: 10px;

  @media (max-width: 767px) {
    --ctl-h: 40px; /* 모바일에서 살짝 키워 가독성 확보 */
    gap: 8px;
  }
`;

const SearchSelect = styled.select`
  height: var(--ctl-h);
  display: flex;
  align-items: center;
  box-sizing: border-box;
  font-size: 14px;
  font-weight: bold;
  padding: 0 34px 0 10px; /* 화살표 공간만큼 오른쪽 패딩 확보 */
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background: #fff url(${arrowIcon}) no-repeat right 10px center; /* 화살표 세로 중앙 */
  background-size: 12px auto;
  border: 1px solid #ccc;
  border-radius: 4px; /* input과 동일하게 */
  font-family: 'koPubWorld DotumB';

  @media (max-width: 767px) {
    font-size: 15px;
  }
  @media (max-width: 375px) {
    font-size: 14px;
  }
  @media (max-width: 320px) {
    font-size: 12px;
  }
`;

const SearchInput = styled.input`
  height: var(--ctl-h);
  box-sizing: border-box;
  width: 240px;
  font-size: 14px;
  padding: 0 10px; /* 세로 패딩 0으로 라인하이트 이슈 제거 */
  border: 1px solid #ccc;
  border-radius: 4px; /* select와 동일하게 */
  font-family: 'koPubWorld DotumB';

  @media (max-width: 767px) {
    flex: 1;
    width: auto;
    font-size: 14px;
  }
  @media (max-width: 375px) {
    font-size: 13px;
  }
  @media (max-width: 320px) {
    font-size: 12px;
  }
`;

const SearchButton = styled.button`
  height: var(--ctl-h);
  width: var(--ctl-h); /* 정사각형 버튼로 높이 맞춤 */
  display: inline-flex;
  align-items: center;
  justify-content: center;

  background: none;
  border: 1px solid #fff; /* 라인 맞추기 */
  border-radius: 4px;
  cursor: pointer;
  padding: 0;
  box-sizing: border-box;

  img {
    width: 100%; /* 버튼 안에서 적당히 */
    display: block;
  }
`;
